//加密
import { encrypt } from "@csp/utils";
const pubkey =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA238jKnNBfpScmXqzNpevHkZmguWdmrLwICAXCc6OCd3kKotC8S2Ovpf5KrBmeEvhGVgc4ihPac+mI9iJdtNwF8i79ZDiPEg2jYmhCnjzGNpJ1uQF47W9lSiVKVHQFF3KpEMhUpK7SApcX4nlh56lwpVf7SaMUD/qr7oDGgnsVDBWo1up2ZqRjOCnkQdgqh7Ls/s7EsdpizWdO5++Xfb9FmCjfnbgGA0JfaLl8CGtWGWdTo+qeWJAKYvuNC9udpWr6ISNQW7u8WxpPvW8c5UmWxpCK6272igRGZgJWEr4RmCAoaOgqOW1ecnqeUfx6v5NKrsv357P3r2kN2qB4oh5dwIDAQAB";

export const encryptParams = (params = {}) => encrypt(pubkey, params);
